import styled from 'styled-components';

export const RightPage = styled.div`
  width: 6.1rem;
  height: auto;
  padding: 0.2rem;
  padding-bottom: 0px;
  box-sizing: border-box;
`;

export const RightTopBox = styled.div`
  position: relative;
  flex: 3;
  width: 100%;
  .right-top {
    &-content {
      display: flex;
      justify-content: space-between;
      align-items: center;

    }
    .earth-gif {
      width: 2.75rem;
      height: auto;
      border-radius: 50%;
      overflow: hidden;
    }
  }
`;

export const RightCenterBox = styled.div`
  position: relative;
  flex: 3;
  height: 2.7rem;
  width: 100%;
  //margin-top:0.215rem;
`;

export const RightBottomBox = styled.div`
  position: relative;
  flex: 4;
  height: 3.1rem;
  width: 100%;
  margin-top: 1.6rem;

  //.DeviceOrderChart{
  //  position: relative;
  //  margin-bottom: 2rem;
  //}
  .right-bottom-borderBox13 {
    padding: 0.25rem 0.1875rem 0.1875rem;
    //.right-bottom {
    //  width: 100%;
    //  height: 100%;
    //  border-radius: 10px;
    //  background-color: rgba(19, 25, 47, 0.6);
    //  .feedback-box {
    //    margin-top: 0.1rem;
    //    display: flex;
    //    align-items: center;
    //    justify-content: space-around;
    //    &-item {
    //      display: flex;
    //      align-items: center;
    //      flex-direction: column;
    //      height: 1.75rem;
    //      .dis-text {
    //        font-weight: bold;
    //        margin-top: 0.0625rem;
    //        color: #b2cfee;
    //        font-size: 0.2rem;
    //        background: linear-gradient(to bottom, #fff, #6176F4);
    //        color: transparent;
    //        -webkit-background-clip: text;
    //        background-clip: text;
    //      }
    //    }
    //  }
    //  .offline-portal-box {
    //    margin-top: 0.125rem;
    //  }
    //}
  }
`;

export const IndustryPieCharts = styled.div`
  position: relative;
  margin-left: 0.2rem;
  //margin-bottom: 5rem;
  .pie-charts-container {
    display: flex;
    gap: 20px;
    width: 100%;
    height: 400px; /* 确保高度足够，可根据需求加大 */
    padding: 20px; /* 内边距，避免内容贴边 */
    box-sizing: border-box;
  }

  .pie-chart-item {
    flex: 1;
    min-width: 200px; /* 给每个饼图容器最小宽度，避免压缩过狠 */
    height: 100%;
  }
  //.legend-multi-column {
  //  display: flex !important; /* 启用弹性布局 */
  //  flex-wrap: wrap; /* 超出容器宽度时换行 */
  //  max-width: 300px; /* 限制容器宽度，触发换行 */
  //  justify-content: center; /* 居中对齐 */
  //}
  //
  //.legend-multi-column .echarts-legend-item {
  //  width: 33.33%; /* 每列占比（3列为例） */
  //  box-sizing: border-box;
  //  padding: 5px 0;
  //}
`;

// 新增DeviceOrderChart样式
export const DeviceOrderChart = styled.div`
  width: 10%;
  max-width: 100%; /* 确保在移动端适配 */
  height: 2.5rem; /* 图表高度，可根据需求调整 */
  //position: relative;
  //top:-2rem;
  //margin-bottom: 0.5rem;
  //padding-bottom: 1.2rem;
  background-color: rgba(19, 25, 47, 0.8); /* 与现有样式统一背景 */
  border: 1px solid #343f4b;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); /* 阴影效果 */
  //padding: 0.5rem;
  //margin-top: 0.5rem; /* 与上方元素间距 */
  padding-right: 1rem;

  /* 响应式适配 */
  @media (min-width: 768px) {
    height: 4.5rem;
    max-width: 80%; /* 桌面端固定最大宽度 */
  }
`;
